import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,formStyles,dialog,details,grid,markdown } from '../../utilities/styles';
import { arrowBack,editIcon, deleteIcon,addIcon,close,clock,address,web,provisionIcon, yellowTick,expandIcon,collapseIcon,submit,star,smallX } from '../../utilities/icons';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, getUrlFromFileId, validateURL, validatePhone, releaseFormLockwithBeacon } from '../../utilities/formsUtilities';
import { AllInMemberConsumer } from '../Utilities/AllInMemberConsumer';
import { AllInMembersBase } from '../Utilities/AllInMembersBase';
import { eventTypes } from '../../utilities/eventUtilities';
import { formatDateString } from '../../utilities/eventUtilities';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { handle403s } from '../../utilities/AllInErrorHandling';
export class AllInMemberDocumentForm extends AllInMemberConsumer(AllInMembersBase(LitElement)){
    static properties = {
        name: { type: String },
        view: { type: String },
        _processedProvisions: {type: Array, state:true},
        _message: {type:String, state:true},
        _formProvision: {type:Object, state:true},
        _selectedDocumentName: { type: String, state: true }
    }

    constructor() {
        super();
    }

    get _form(){
        return this.shadowRoot.querySelector('form');
    }

    async connectedCallback() {
        super.connectedCallback();
        //this.renderRoot.querySelector('a')?.focus();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }

    async updated(changedProperties){
        if(changedProperties.has('panel')){
            if(this.panel){
                this.renderRoot.querySelector('input')?.focus();
                let supportingDocuments = this._getEvidenceRequiredProvisions(true);
                this._formProvision = supportingDocuments.find((p)=>p.standard.id==this.panel);
                let name = this._formProvision.standard.name;
                let crumb = {title:name,dashboard:{url:`/dashboard/${this.dashboard}`,title:msg('Submit my supporting documents')},panel:{url:`/dashboard/${this.dashboard}/${this.panel}`,title:name}};
                this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
                this._setDocumentTitle(name);
                //change title
                this.eventManager.emit(`allin-header-${this.name}`, {text: name, name: this.name});
            }
            else{
                this.renderRoot.querySelector('a')?.focus();
                //revert title
                let crumb = {title:name,dashboard:{url:`/dashboard/${this.dashboard}`,title:msg('Submit my supporting documents')}};
                this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
                this._setDocumentTitle(msg('Submit my supporting documents'));
                this.eventManager.emit(`allin-header-${this.name}`, {revert: true,name: this.name});
            }
            if(this.panel){
                this._message = '';
            }
        }
    }

    render() {
        let main='';
        if(!this.membership){
            return html`<allin-loader></allin-loader>`;
        }
        let evidenceRequired = this._getEvidenceRequiredProvisions();
        /* if(!this.membership.isIdentityVerified&&!this.membership.isYotiSubmitted&&evidenceRequired&&evidenceRequired.length > 0){
            main = html`
                <div class="message">
                    <h3>${msg(`ID verification`)}</h3>
                    <p>${msg(`You need to verify your identity before submitting your supporting document.`)}</p>
                    <a href="javascript:void(0)" class="button" @click=${this._handleVerifyID}>${msg(`Verify ID`)}</a>
                </div>
            `;
        }
        else  */
        if(this.panel){
            if(!this._formProvision){
                main = html`<allin-loader></allin-loader>`;
            }
            else{
                let evidenceID = this._formProvision.evidence.length > 0?this._formProvision.evidence[0].id:null;
                main = html`
                    <a href="javascript:void(0)" class="return" @click=${()=>{this._updateContext({panel:''});this._selectedDocumentName = null;}}><span aria-hidden=true>${arrowBack}</span>${msg(`Back to my supporting documents`)}</a>
                    <form @submit=${this._handleSubmit}>
                        <div class="message form_response" aria-live="polite">
                            ${this._message}
                        </div>
                        <p>${msg(`Submit supporting document for`)} ${this._formProvision.details.name}</p>
                        <div class="bg bg_grey">
                            <input type="hidden" name="provisionId" value="${this._formProvision.id}" />
                            <input type="hidden" name="action" value="add_evidence" />
                            <input type="hidden" name="evidenceId" value="${evidenceID}" />
                            <div class="input-group">
                                <label for="documentName">${msg(`Please add title for the supporting document`)}</label>
                                <select name="documentName" id="documentName" required aria-required="true" @change=${(e) => this._selectedDocumentName = e.target.value}>
                                    <option value="" disabled selected>${msg(`Select a title`)}</option>
                                    ${this._formProvision?.standard?.id === '9b6ca986-7bd8-41da-998c-9db0ba7448a5'|| this._formProvision?.standard?.id === '1d018257-2ccc-4a44-a94d-8f93dd4c3771'? html`
                                        <option value="${msg(`Service Animal insurance document`)}">${msg(`Service Animal insurance document`)}</option>
                                        <option value="${msg(`Assistance Dog ID book`)}">${msg(`Assistance Dog ID book`)}</option>
                                        <option value="${msg(`Assistance Dog ID card`)}">${msg(`Assistance Dog ID card`)}</option>
                                        <option value="${msg(`Other`)}">${msg(`Other`)}</option>
                                    ` : this._formProvision?.standard?.id === '76c029e4-b3bb-4f67-a5b2-8f2edecdc267'|| this._formProvision?.standard?.id === '0dc86072-28ae-4a90-a647-737003e20cdd' ? html`
                                        <option value="${msg(`Current access card`)}">${msg(`Current access card`)}</option>
                                        <option value="${msg(`Personal Independence Payment (PIP) letter`)}">${msg(`Personal Independence Payment (PIP) letter`)}</option>
                                        <option value="${msg(`Disability Living Allowance (DLA) letter`)}">${msg(`Disability Living Allowance (DLA) letter`)}</option>
                                        <option value="${msg(`Blue badge (both sides)`)}">${msg(`Blue badge (both sides)`)}</option>
                                        <option value="${msg(`Disabled Person’s Freedom Pass`)}">${msg(`Disabled Person’s Freedom Pass`)}</option>
                                        <option value="${msg(`Disabled Person’s Railcard`)}">${msg(`Disabled Person’s Railcard`)}</option>
                                        <option value="${msg(`GP/Medical consultant letter`)}">${msg(`GP/Medical consultant letter`)}</option>
                                        <option value="${msg(`Certificate of Visual Impairment (CVI)`)}">${msg(`Certificate of Visual Impairment (CVI)`)}</option>
                                        <option value="${msg(`Other`)}">${msg(`Other`)}</option>
                                    ` : html`
                                        <option value="${msg(`Other`)}">${msg(`Other`)}</option>
                                    `}
                                </select>
                            </div>
                            
                            ${this._selectedDocumentName === msg('Other') ? html`
                                <div class="input-group">
                                    <label for="otherDocumentName">
                                        ${msg(`If Other, please specify`)}
                                    </label>

                                    <input
                                        type="text"
                                        id="otherDocumentName"
                                        name="otherDocumentName"
                                        aria-required="true"
                                    />
                                </div>
                            ` : ''}

                            <div class="input-group">
                                <label for="evidence"><h3>Upload supporting document</h3></label>
                                <allin-multiloader buttontext="${msg(`Upload additional supporting documents`)}">
                                    <div class='group show'>
                                        <div class="input-group">
                                            <input type='file' name='evidence_1' id='evidence_1' accept='image/png, image/jpeg, image/webp, application/pdf' aria-required="true" />
                                            <p class="small">${msg(`Accepted file types: PNG, JPEG, WEBP, PDF. Max file size: 10MB.`)}</p>
                                        </div>
                                    </div>
                                    <div class='group'>
                                        <div class="input-group">
                                            <input type='file' name='evidence_2' id='evidence_2' accept='image/png, image/jpeg, image/webp, application/pdf'/>
                                            <p class="small">${msg(`Accepted file types: PNG, JPEG, WEBP, PDF. Max file size: 10MB.`)}</p>
                                        </div>
                                    </div>
                                    <div class='group'>
                                        <div class="input-group">
                                            <input type='file' name='evidence_3' id='evidence_3' accept='image/png, image/jpeg, image/webp, application/pdf' />
                                            <p class="small">${msg(`Accepted file types: PNG, JPEG, WEBP, PDF. Max file size: 10MB.`)}</p>
                                        </div>
                                    </div>
                                </allin-multiloader>
                                ${this._formProvision.details.evidenceInstructions?html`<p class="small provision-docs-exp">${unsafeHTML(this._formProvision.details.evidenceInstructions)}</p>`:''}
                            </div>
                            <input type="submit" value="${msg(`Submit`)}" class="button">
                        </div>
                    </form>
                `;
            }
        }
        else{
            let message = '';
            let supportingDocuments = this._getEvidenceRequiredProvisions(true);
           /*  if(!this.membership.isIdentityVerified&&this.membership.isYotiSubmitted && supportingDocuments&&supportingDocuments.length > 0){
                message = html` 
                <div class="message">
                    <h3>${msg(`ID verification`)}</h3>
                    <p>${msg(`Your ID verification is in progress.`)}</p>
                </div>`;
            } */
            let supportingDocumentsStr = '';
            if(supportingDocuments&&supportingDocuments.length > 0){
                let docsArray = supportingDocuments.map((provision)=>{
                    let status = msg(str`Not submitted yet`);
                    let submissionOpen = true;
                    let latestEvidence;
                    let note = '–';
                    let documentName = '–';
                    let validUntil = '–';
                    if(provision.evidence.length > 0){
                        let sortedEvidence = provision.evidence.sort((a,b)=>new Date(b.validUntil) - new Date(a.validUntil));
                        latestEvidence = sortedEvidence[0];
                        documentName = latestEvidence.documentName?latestEvidence.documentName:'–';
                        if(latestEvidence.status=='Approved'){
                            status = msg(str`Valid`);
                            if(latestEvidence.validUntil){
                                validUntil = formatDateString(latestEvidence.validUntil, false, false);
                                if(new Date(latestEvidence.validUntil) < new Date()){
                                    status = msg(str`Expired on ${validUntil}`);
                                }
                                else{
                                    submissionOpen = false;
                                    status = msg(str`Valid until ${validUntil}`);
                                }
                            }
                            else{
                                submissionOpen = false;
                            }
                        }
                        else if(latestEvidence.status=='Rejected'){
                            status = msg(str`Rejected`);
                            submissionOpen = true;
                            note = latestEvidence.note;
                        }
                        else if(latestEvidence.status=='AwaitingResponse'){
                            status = msg(str`Submitted, awaiting review`);
                            submissionOpen = false;
                        }
                        else if(latestEvidence.status=='RequestInfo'){
                            status = msg(str`More information required`);
                            submissionOpen = true;
                            note = latestEvidence.note;
                        }
                    }
                    return html`
                    <div class="message profile-card ">
                        <dl>
                            <dt>Provision</dt><dd>${provision.details.name}</dd>
                            <dt>Valid until</dt><dd>${validUntil}</dd>
                            <dt>Supporting document title</dt><dd>${documentName}</dd>
                            <dt>Status</dt><dd>${status}</dd>
                            <dt>Note</dt><dd>${note}</dd>
                        </dl>
                        ${submissionOpen?
                            html`<hr><a href="javascript:void(0)" @click=${()=>this._updateContext({panel:provision.standard.id})}><span aria-hidden=true>${addIcon}</span>${msg(`Upload supporting document`)}</span></a>`:''}
                    </div>
                    `;
                });
                supportingDocumentsStr = html`
                    ${docsArray}
                `;
            }
            else{
                supportingDocumentsStr = html`<p>${msg(`No supporting documents required at this time.`)}</p>`;
            }

            
            main = html`
                ${message}
                   
                    <h3>${msg(`My supporting document status`)}</h3>
                    ${supportingDocumentsStr}
                </div>
            `;
        }

        return html`${main}`;
    }

    async _handleVerifyID(e){
        e.preventDefault();
        e.target.disabled = true;
        e.target.setAttribute('aria-busy','true');
        e.target.classList.add('loading');
        let url = `${this.restUrl}?action=get_yoti_session&nonce=${this.nonce}`;
        try{
            const response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            const data = await response.json();
            if(!data.error){
                window.location.href = data.sessionUrl;
            }
            else{
                this._message = data.message || msg(`An error occurred while trying to verify your identity. Please try again.`);
            }
        }
        catch(error){
            console.error('Error:', error);
            this._message = msg(`An error occurred while trying to verify your identity. Please try again.`);
        }
        finally{
            e.target.disabled = false;
            e.target.setAttribute('aria-busy','false');
            e.target.classList.remove('loading');
        }
    }



    async _handleSubmit(e){
        e.preventDefault();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        this._message = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');

        //validate the new other field
        const documentName = this._form.querySelector('#documentName')?.value;
        const otherField = this._form.querySelector('#otherDocumentName');

        if (documentName === msg('Other')) {
            if (!otherField?.value?.trim()) {
                formResponse.innerHTML = msg('Please specify the document title for Other option');
                formResponse.classList.add('error');
                formResponse.scrollIntoView();
                return;
            }
        }

        let valid = validateForm(this._form,formResponse);
        if(!valid){ 
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        if (formData.get('documentName') === msg('Other')) {
            formData.set('documentName', formData.get('otherDocumentName'));
        }
        //formData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try{
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })

            //show logged out modal if session has expired
            if(response.status === 403){
                handle403s();
                return;
            }

            response = await response.json();
            if(!response.error){
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                this.membership = response.membership;
                submitButton.disabled = false; 
                formResponse.innerHTML = msg('Your changes have been saved');
                this._message = msg('Your changes have been saved');
                this._updateContext({membership:this.membership,panel:''});
            }
            else{
                formResponse.innerHTML = response.message || 'An error occurred';
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false; 
            }
        }
        catch(error){
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        };
    }


    static styles = [
        ...super.styles,
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        markdown,
        css`
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .profile-card a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .profile-card a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }
        .small.provision-docs-exp a{
            color: #472961;
            display: block;
        }

        input[type=submit]{
            width: 100%;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {

            .button-group button:hover svg, .return:hover svg{
                transform:none;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child:not(.duet-date__cell){
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
                background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
                font-weight: var(--allin-button-font-weight, 600);
                color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            max-height:0;
            overflow:hidden;
            transition:all var(--transition) ease;
            transition-behavior: allow-discrete;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            max-height:700px;
            box-sizing: border-box;
            overflow:visible;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        .add_uploader{
            background-color: var(--allin-button-bg-color, #472961);
            color: #fff;
            margin-bottom: 1.5rem;
        }
        .add_uploader span svg {
            background-color: #fff;
            transform: translate(0px, 3px);
        }

        .add_uploader:hover span svg {
            background-color: transparent;
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1rem;

            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem 0.5rem 3rem;
            &:has(>.field-group){
                padding-left:1rem;
            }
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .instances{
            padding:0;
            margin:0;
            list-style:none;
        }

        .instances li:not(:last-child){
            margin-bottom:1rem;
            padding-bottom:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
        }

        @media screen and (min-width:700px){
            .instances dl{
                display:grid;
                grid-template-columns: max-content 1fr;
                gap:1rem;
            }
        }



        .instances dl dt{
            font-weight:500;
        }
        
        dd h4{
            margin:0 0 0.5rem 0;
        }

        dd p{
            margin-bottom:1rem;
        }
        p:has(+.provisions){
            grid-column: 1 / -1;
            margin-top:2rem;
            margin-bottom:0;
        }
        .repeater{
            padding:0 2rem;
        }
        allin-location-search .bg{
            background-color:var(--color-bg);
        }
        allin-location-search ul{
            list-style:none;
            padding:0;
            margin:1rem 0;
        }
        allin-location-search li, allin-location-search .selected-location{
            margin-bottom:0.5rem;
            display:grid;
            grid-template-columns: 3rem 1fr auto;
            gap:1rem;
            align-items:center;
            img{
                width:3rem;
                height:3rem;
                object-fit:cover;
            }
            button{
                height:fit-content;
            }
        }
        .searchboxes {
            display: grid;
            grid-template-columns: 1fr auto;
            width: 100%;
            max-width: 800px;
            margin-bottom: 2rem;
            position:relative;
        }

        .searchbox {
            position: relative;
            label {
                margin-bottom: 0.5rem;
            }
        }
        .searchbox svg {
            position: absolute;
            left: 0.5rem;
            bottom: 0.8rem;
            width: 1.5rem;
            height: 1.5rem;
        }

        .searchbox input{
            padding-left:2.5rem;
            border-radius:0.5rem 0 0 0.5rem;
        }
        .searchboxes button{
            border-radius:0 0.5rem 0.5rem 0;
            height:calc(3rem + 2px);
            align-self:end;
        }
        .no-location button{
            margin:1rem 0 0 auto;
            display:block;
        }

        button.back{
            color:var(--allin-highlight-color,#472961);
            background-color:transparent;
            border:0;
            padding:0;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:0.5rem;
        }
        button.back span{
            display:flex;
            align-items:center;
            justify-content:center;
            width:1rem;
        }
        button.back svg{
            transform:rotate(0);
            transition:transform var(--transition) ease;
            width:1rem;
        }
        button.back:hover{
            text-decoration:underline;
        }

        button.back:hover svg{
            transform:rotate(15deg);
        }

        @media (prefers-reduced-motion: reduce) {
            button.back svg{
                transform:none !important;
            }
        }
        .grid--status{
            grid-template-columns: 10ch 1fr;
            gap:1rem;
            align-items:center;
            .status{
                padding:0.15rem;
                border:1px solid #000;
                strong{
                    display:flex;
                    align-items:center;
                    gap:0.2rem;
                    span{
                        width:1rem;
                        height:1.2rem;
                        display:block;
                    }
                    svg{
                        width:1rem;
                        height:1rem;
                    }
                }
            }
            
        }
        @media screen and (min-width:700px){
            dl>a{
                grid-column:2/3;
                margin-top:0.5rem;
            }
        }
        .bg+.bg{
            margin-top:3rem;
        }
        .field-group{
            padding:1rem 0;
            border-top:1px solid var(--allin-border-color,#707070);
            &+.field_group{
                margin-top:1rem;
            }
            allin-tooltip{
                justify-self: end;
            }
            .input-group{
                gap:0.4rem;
                
                align-items: center;
                input{
                   margin:0;
                }
                label{
                    max-width:unset;
                    font-weight:400;
                    display:flex;
                    align-items: center;
                    gap:0.1rem;
                    svg,span{
                        height:0.75rem;
                        width: 0.75rem;
                    }
                    span{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                    }
                }
            }
        }
        @media screen and (min-width:1000px){
            .field-group{
                grid-template-columns: 3fr 1fr;   
                gap:1rem;         
                .input-group{
                   margin-bottom:0; 
                }
            }
        }
        form{
            gap:0;
        }
        .h5{
            font-size:1rem;
            margin:0 0 0.5rem;
        }
        .preferences-header{
            justify-content:flex-start;
            gap:2rem;
            align-items:center;
            p{
                margin:0;   
            }
        }
        input[type='file']{
            background-color:transparent!important;
        }

        ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

         ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }

        .message{
            .button{
                margin-bottom:1rem;
                display:inline-block;
                padding-left:3rem;
                padding-right:3rem;
            }
        }

        label h3{
            margin-top:0;
            margin-bottom:0;
        }
        p.small{
            margin-bottom:0;
        }
        `
        ];
        
}